import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import { HISTORY_SCOPE } from '@src/constants/history';

const isUndoCombo = (event) => {
  const modifier = event.metaKey || event.ctrlKey;
  return modifier && !event.shiftKey && (event.key || '').toLowerCase() === 'z';
};

const isRedoCombo = (event) => {
  const modifier = event.metaKey || event.ctrlKey;
  return modifier && event.shiftKey && (event.key || '').toLowerCase() === 'z';
};

const shouldSkipForActiveElement = (scope) => {
  const active =
    typeof document !== 'undefined' ? document.activeElement : null;
  if (!active) return false;
  const tag = active.tagName;
  if (tag !== 'INPUT' && tag !== 'TEXTAREA') return false;
  return active.dataset?.historyShortcut !== scope;
};

const useUndoRedoShortcuts = (
  scope = HISTORY_SCOPE.DUBBING,
  { disabled = false } = {},
) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isUndoCombo(event) && !isRedoCombo(event)) return;
      if (disabled) return;
      if (shouldSkipForActiveElement(scope)) return;

      event.preventDefault();
      if (isRedoCombo(event)) {
        dispatch(actions.history.redo(scope));
      } else {
        dispatch(actions.history.undo(scope));
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [disabled, dispatch, scope]);
};

export default useUndoRedoShortcuts;
